// Utilities
export { cn } from './cn';

// Components
export { Button, type ButtonProps, buttonVariants } from './components/button';
export { Input, type InputProps } from './components/input';
export { PasswordInput, type PasswordInputProps } from './components/password-input';
export { Label, type LabelProps } from './components/label';
export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
} from './components/card';
export { Separator } from './components/separator';
export { Alert, AlertTitle, AlertDescription, alertVariants } from './components/alert';
export { Spinner } from './components/spinner';
export { Skeleton, type SkeletonProps } from './components/skeleton';
export { TableSkeleton, type TableSkeletonProps, type TableSkeletonColumn } from './components/table-skeleton';
export { FormSkeleton, type FormSkeletonProps } from './components/form-skeleton';
export { CardSkeleton, type CardSkeletonProps } from './components/card-skeleton';

export { ConfirmDialog } from './components/confirm-dialog';
export { Pagination } from './components/pagination';
export { Badge } from './components/badge';
export { EmptyState } from './components/empty-state';

// Data table — generic listing component (Faza 1 din refactor multi-pagini)
export { DataTable } from './components/data-table';
export { DataTableFilter, isFilterActive, applyFilter } from './components/data-table-filter';
export { DataTablePagination } from './components/data-table-pagination';
export type {
  ColumnDef,
  DataTableProps,
  FilterConfig,
  FilterType,
  FilterState,
  FilterValue,
  SortDir,
  SortState,
} from './components/data-table-types';

// Document list shell — wrapper layout pentru pagini de listing (Faza 2)
export { DocumentListShell } from './components/document-list-shell';
export { DocumentListShellPeriod } from './components/document-list-shell-period';
export { DocumentListShellCustomize } from './components/document-list-shell-customize';
export { DocumentListShellTabs } from './components/document-list-shell-tabs';
export type {
  SavedView,
  WidgetGroup,
  WidgetGroupItem,
  PrimaryAction,
  DateRange,
  DocumentListShellProps,
} from './components/document-list-shell-types';

// Theme
export {
  PALETTE_PRESETS,
  DEFAULT_PRESET_ID,
  hexToRgb,
  hexToRgbTriplet,
  generateScale,
  luminance,
  contrastRatio,
  ensureUsable,
  type Shade,
  type ColorScale,
  type PalettePreset,
  getSurfaceMutedHex,
  BG_TONE_OPTIONS,
  type BgTone,
} from './theme/palette-presets';
